import { Stack, Typography, styled, Box } from '@mui/material';

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexFlow: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-around',
  width: '262px',
  height: 'auto',
  padding: theme.spacing(1.5),
  borderRadius: '8px',
  cursor: 'pointer',
  ...theme.mixins.defaultTransition,
  '&:hover': {
    '& .MuiTypography-root:first-of-type': theme.mixins.hoverTextLightBlue,
  },
  [theme.breakpoints.up('md')]: {
    '&:hover': {
      background: '#F2F4F8',
    },
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    justifyContent: 'flex-start',
    padding: 0,
  },
}));
export const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.colorGrey?.primary,
  marginTop: theme.spacing(1),
}));
export const StyledHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.colorBrand?.primary,
  ...theme.mixins.defaultTransition,

  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
}));
export const StyledImage = styled(`img`)(({ theme }) => ({
  opacity: 0,
  position: 'absolute',
  ...theme.mixins.defaultTransition,
}));
export const StyledImageWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '24px',
  height: '24px',
  marginRight: theme.spacing(2),
  marginBottom: theme.spacing(0.5),
  ...theme.mixins.defaultTransition,
}));
export const StyledTextWrapper = styled(Stack)(({ theme }) => ({
  ...theme.mixins.flexColumnStartStart,
  margin: theme.spacing(0.25, 0, 0, 0.5),
  [theme.breakpoints.down('md')]: {
    margin: 'unset',
  },
}));
